import { createContext } from "react"

import type { FilterRendererSize, FilterRendererVariant } from "./typings"

interface IFilterRendererContext {
	size: FilterRendererSize
	variant: FilterRendererVariant
}

export const FilterRendererContext = createContext({} as IFilterRendererContext)
